// Icons
import {
    AdjustmentsHorizontal,
    ClipboardCheck,
    GridDots,
    HeartRateMonitor,
    Package,
    Point,
    ReportAnalytics,
    Settings,
    Urgent,
    Users,
    Logout,
    Checkbox,
    Affiliate,
} from 'tabler-icons-react';

// Route Components
// This should come from pages/ and not from routes.
// import MyAccount from '../pages/MyAccount.jsx';
import CalendarProduc from './calendarProduc.js';
import Fallas from '../pages/Fallas';
import OrdenProduc from '../pages/ListaOrdenes';
import Productos from '../pages/Products';
import Turnos from '../pages/Shifts';
import Festivos from '../pages/Holidays';
import Llamadas from '../pages/Llamadas';
import LogOut from './LogOut.js';
import Home from '../pages/Home';
import Monitoreo from '../pages/Monitoreo';
import Capacidades from '../pages/Capacidades';
import Usuarios from '../pages/Usuarios';
import Reportes from '../pages/Reportes';
import Inventarios from '../pages/Inventarios';
import Cuenta from '../pages/Cuenta/index.jsx';
import Telegram from '../pages/Telegram/index.jsx';
import NoProduccion from '../pages/NoProduccion/index.jsx';
import Calidad from '../pages/Calidad';
import BuildInfo from '../pages/BuildInfo/index.jsx';
import MachineLearning from '../pages/ML/index.jsx';

export const menuItemFilter = {
    monitoreo: process.env.REACT_APP_ALLOW_MONITORING_VIEW === 'true',
    reportes: process.env.REACT_APP_ALLOW_REPORTS_VIEW === 'true',
    ordenes: process.env.REACT_APP_ALLOW_ORDERS_VIEW === 'true',
    machineLearning: process.env.REACT_APP_ALLOW_IA_VIEW === 'true',

    productos: process.env.REACT_APP_ALLOW_PRODUCTS_VIEW === 'true',
    alertas: process.env.REACT_APP_ALLOW_ALERTS_VIEW === 'true',
    parametros: process.env.REACT_APP_ALLOW_SETTINGS_VIEW === 'true',
    usuarios: process.env.REACT_APP_ALLOW_USERS_VIEW === 'true',
    inventarios: process.env.REACT_APP_ALLOW_STOCKLIST_VIEW === 'true',
    config: process.env.REACT_APP_ALLOW_USER_SETTINGS_VIEW === 'true',
};

export const routeList = [
    {
        id: 'home',
        text: 'Panel Principal',
        icon: GridDots,
        path: '/',
        component: Home,
    },
    {
        id: 'monitoreo',
        text: 'Monitoreo',
        icon: HeartRateMonitor,
        path: '/monitoreo',
        component: Monitoreo,
    },

    {
        id: 'reportes',
        text: 'Reportes',
        icon: ReportAnalytics,
        path: '/reportes',
        component: Reportes,
    },
    {
        id: 'ordenes',
        text: 'Órdenes de Producción',
        icon: ClipboardCheck,
        path: '/ordenes',
        isModal: false,
        component: OrdenProduc,
        children: [
            {
                id: 'ordenes-lista',
                text: 'Lista de ordenes',
                icon: Point,
                path: '/ordenes/lista',
                component: OrdenProduc,
            },
            {
                id: 'ordenes-calendario',
                text: 'Calendario de ordenes',
                icon: Point,
                path: '/ordenes/calendario',
                component: CalendarProduc,
            },
        ],
    },
    {
        id: 'machineLearning',
        text: 'IA',
        icon: Affiliate,
        path: '/ML',
        component: MachineLearning,
    },
    {
        id: 'productos',
        text: 'Productos',
        icon: Package,
        path: '/productos',
        component: Productos,
    },
    {
        id: 'alertas',
        text: 'Fallas, llamadas y alertas',
        icon: Urgent,
        path: '/alertas',
        component: Fallas,
        children: [
            {
                id: 'alertas-fallas',
                text: 'Fallas',
                icon: Point,
                path: '/alertas/fallas',
                component: Fallas,
            },
            {
                id: 'alertas-llamadas',
                text: 'Llamadas',
                icon: Point,
                path: '/alertas/llamadas',
                component: Llamadas,
            },
            {
                id: 'alertas-noprod',
                text: 'Alertas (No Producción)',
                icon: Point,
                path: '/alertas/noprod',
                component: NoProduccion,
            },
            {
                id: 'alertas-calidad',
                text: 'Calidad',
                icon: Point,
                path: '/alertas/calidad',
                component: Calidad,
            },
        ],
    },
    {
        id: 'parametros',
        text: 'Parámetros',
        icon: AdjustmentsHorizontal,
        path: '/parametros',
        component: Home,
        children: [
            {
                id: 'parametros-ritmo',
                text: 'Ritmo Base',
                icon: Point,
                path: '/parametros/ritmo',
            },
            {
                id: 'parametros-turnos',
                text: 'Turnos',
                icon: Point,
                path: '/parametros/turnos',
                component: Turnos,
            },
            {
                id: 'parametros-capacidad',
                text: 'Capacidades por default',
                icon: Point,
                path: '/parametros/capacidad',
                component: Capacidades,
            },
            {
                id: 'parametros-festivos',
                text: 'Festivos',
                icon: Point,
                path: '/parametros/festivos',
                component: Festivos,
            },
        ],
    },
    {
        id: 'usuarios',
        text: 'Usuarios y Roles',
        icon: Users,
        path: '/usuarios',
        component: Usuarios,
    },
    {
        id: 'inventarios',
        text: 'Inventarios',
        icon: Checkbox,
        path: '/inventarios',
        component: Inventarios,
    },
    {
        id: 'build-info',
        text: 'build-info',
        icon: Checkbox,
        path: '/dev/build-info',
        component: BuildInfo,
    },
    {
        id: 'config',
        text: 'Configuración',
        icon: Settings,
        path: '/config',
        component: Home,
        children: [
            {
                id: 'config-cuenta',
                text: 'Mi Cuenta',
                icon: Point,
                path: '/config/cuenta',
                component: Cuenta,
            },
            {
                id: 'config-telegram',
                text: 'Telegram',
                icon: Point,
                path: '/config/telegram',
                component: Telegram,
            },
        ],
    },
];

export const cerrarSesion = [
    {
        id: 'LogOut',
        text: 'Cerrar Sesión',
        icon: Logout,
        path: '/LogOut',
        component: LogOut,
    },
];
